import { Link } from 'react-router-dom';

// Purpose: Footer component for the landing page with legal links
export const Footer = () => {

  return (
    <footer className="pt-12 pb-8 border-t border-gray-200" style={{ backgroundColor: '#1C1E24', color: 'white' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between">
          {/* Company info */}
          <div className="mb-8 md:mb-0">
            <h3 className="text-lg font-semibold mb-4 text-white">BigTuna Solutions</h3>
            <p className="text-gray-300 max-w-xs">
              Founded in 2017, Big Tuna Solutions helps brokers and lenders grow through expert web development, marketing, lead generation, and CRM automation.
            </p>
          </div>

          {/* Links section */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            {/* Products column */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white">Products</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/#features"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Features
                  </Link>
                </li>
                <li>
                  <Link to="/#pricing" className="text-gray-300 hover:text-blue-400 transition-colors">
                    Pricing
                  </Link>
                </li>
              </ul>
            </div>

            {/* Resources column */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white">Resources</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">
                    Support
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal column */}
            <div>
              <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-white">Legal</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/legal/terms"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    to="/legal/privacy"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/legal/disclaimer"
                    className="text-gray-300 hover:text-blue-400 transition-colors"
                  >
                    Disclaimers
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
